import {Box, Paper, Typography} from "@mui/material";
import {useLocation} from "react-router-dom";
import {pages} from "../../constants/pages";
import { useTranslation } from "react-i18next";

const BreadCrumb = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const name = location.pathname.split("/")[1];
    let pageName = pages["/"+name];
    if (pageName) {
        const groupNameFallback = location.state?.groupName ?? (name === "order-details" ? t("notif_orderDetails") : "");
        const serviceNameFallback = location.state?.name ?? "";
        
        // Translate the page name if it's a key
        const translatedPageName = t(pageName);
        
        pageName = translatedPageName
            .replace("$groupName", groupNameFallback)
            .replace("$serviceName", serviceNameFallback)
            .replace(/\s*-\s*$/, "")
            .trim();

        if (!pageName.length) {
            pageName = undefined;
        }
    }
    return (
        <Paper sx={{background: "#F9FAFC", overflow: "hidden"}} elevation={2}>
        {pageName &&  <Box sx={{ p: 1.875, background: "#F9FAFC",}}>
            <Typography sx={{fontWeight: "bold"}} variant="h6">{pageName}</Typography>
        </Box>}
        </Paper>
    )
}
export default BreadCrumb;